<div class="kkm-multi-year-view">
  <div *ngFor="let year of years; trackBy:yearIdentity"
       class="kkm-multi-year-view__year"
       [class.kkm-multi-year-view__year_active]="isYearSelected(year)"
       (click)="selectYear(year)">
    {{ year.year }}
  </div>
</div>
